import InstrumentIcon from "../../../../components/instrument-icon";
import React, {useEffect, useState} from "react";
import associateServices from "../../../../services";
import Big from "big.js";
import Loading from "../../../../components/loading";
import {useTranslation} from "react-i18next";
import FormButton from "../../../../components/form-button";
import {useSelector} from "react-redux";
import './index.css'
import ReloadCountBack from "../../../../components/countback";
import SvgIcon from "../../../../components/svg-icon";
import {decrypt, encrypt} from "../../../../helpers/encryption";

const ReloadModal = () => {
    const {t} = useTranslation()
    const [reloads, setReloads] = useState({})
    const [loading, setLoading] = useState(true)
    const [submitting, setSubmitting] = useState(false)
    const [selectedCurrency, setSelectedCurrency] = useState({})

    const {selectedWallet, currencies, currencyList} = useSelector(state => state.authenticationReducer)
    const {modalCurrency} = useSelector(state => state.globalReducer)
    const [search, setSearch] = useState('')
    const [currencyListFiltered, setCurrencyListFiltered] = useState([])

    const [rates, setRates] = useState({})
    const {selectedFiat} = useSelector(state => state.authenticationReducer)

    useEffect(() => {

        if (selectedFiat) {
            const handleFiatRates = e => {
                const data = decrypt(e)
                setRates(data)
            }
            window?.tcpSocket?.emit('fiat:rate', encrypt({
                currency: selectedFiat
            }))

            window?.tcpSocket?.on('fiat:rates', handleFiatRates)


        }

    }, [selectedFiat])


    useEffect(() => {
        setCurrencyListFiltered(currencyList?.filter(i => i.code?.toUpperCase().includes(search?.toUpperCase()) || i.name?.toUpperCase().includes(search?.toUpperCase())))

    }, [currencyList, search])
    useEffect(() => {
        if (modalCurrency) {
            setSelectedCurrency({
                code: modalCurrency
            })
        } else if (selectedWallet?.code) {
            setSelectedCurrency({
                code: selectedWallet.code
            })
        }
    }, [selectedWallet, modalCurrency])
    useEffect(() => {
        setLoading(true)
        getAvailableReloads(selectedCurrency?.code)
    }, [selectedCurrency?.code])

    useEffect(() => {
        if (reloads?.id) {
            checkAvailability(reloads?.id)
        }
    }, [reloads?.id])

    const [buttonAvailable, setButtonAvailable] = useState(false)
    const checkAvailability = (id) => {
        setButtonAvailable(false)
        associateServices.checkAvailableReload(id).then(res => {
            setButtonAvailable(res?.data)

        })
    }
    const getAvailableReloads = (code) => {
        if (!code) {
            console.log('NO CODE FOUND')
            return false;
        }

        associateServices.getAvailableReloads({
            code
        }).then(res => {
            setReloads(res?.data?.length >= 1 ? res?.data[0] : {})
            setLoading(false)
        })
    }


    const handleReload = () => {
        if (submitting)
            return false;

        setSubmitting(true)
        associateServices.reload({
            code: selectedCurrency?.code
        })
            .then(res => {
                setSubmitting(false)
                getAvailableReloads(selectedCurrency?.code)
                checkAvailability(reloads.id)
            })
    }

    const handleChangeWallet = wall => {
        const instances = currencies?.filter(ioi => ioi.alias === wall?.code)

        if (instances)
            setSelectedCurrency({
                code: wall.code
            })

        document.getElementById('modalWalet0')?.classList?.remove('show')
        document.getElementById('dropdown-menu-modal__wallet-menu')?.classList?.remove('show')
        setSearch('')
    }


    const getDisplayCurrency = () => {
        if (!selectedFiat)
            return `${Big(reloads?.conversion || 0).toFixed(8)} ${selectedCurrency?.code}`

        return `${selectedFiat} ${Big(reloads?.usd_amount || 0).times(1 / (rates['USDT'] || 1)).toFixed(2)}`

    }
    return (
        <div>
            {
                loading ? <Loading/> :
                    <>
                        <div
                            className="form__group d-flex flex-column align-items-center justify-content-center flex-wrap gap-4">
                            {
                                reloads?.id ?
                                    <>
                                        {/*<h4 className="form__group text-center align-items-center">{t('reload.title')}</h4>*/}

                                        <div className="d-flex align-items-center">
                                            <button
                                                className="modal__wallet-dropdown-btn"
                                                type="button"
                                                id="modalWalet0"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                <InstrumentIcon code={selectedCurrency?.code}/>
                                                {getDisplayCurrency()}
                                                <SvgIcon id={'right-down'}/>
                                            </button>


                                            <div
                                                className="dropdown-menu modal__wallet-menu"
                                                id="dropdown-menu-modal__wallet-menu"
                                                aria-labelledby="modalWalet0"
                                            >
                                                <div className="modal__wallet-search">
                                                    <div  className="search">
                                                        <input
                                                            value={search}
                                                            onChange={e => setSearch(e.target.value)}
                                                            name="search"
                                                            type="text"
                                                            className="search__input"
                                                            placeholder={t('casino.search','Search')}

                                                            // placeholder="Search"
                                                        />
                                                    </div>
                                                </div>
                                                <ul className="modal__wallet-currencies">
                                                    {
                                                        currencyListFiltered?.map((wall, i) => (
                                                            <li key={i}
                                                                onClick={e => handleChangeWallet(wall)}>
                                                                <span>
                                                                    <InstrumentIcon code={wall?.code}/>
                                                                    {wall?.code}
                                                                </span>
                                                            </li>
                                                        ))
                                                    }

                                                </ul>
                                            </div>
                                        </div>

                                        <FormButton
                                            onClick={handleReload}
                                            label={t('reload.button')}
                                            loading={submitting}
                                            disabled={!buttonAvailable}
                                        />
                                        <div className="d-flex align-items-center justify-content-center gap-2">
                                            <span>
                                                <InstrumentIcon code={'USDT'}/>
                                            </span>
                                            <span className="reload-amount">
                                                    {
                                                        Big(reloads?.usd_amount || 0).toFixed(2)
                                                    } USD
                                            </span>
                                        </div>

                                    </>
                                    : <p>{t('reload.none-yet')}</p>
                            }


                            {
                                <ReloadCountBack nextDate={reloads?.next_claim_ends}/>
                            }

                        </div>

                    </>

            }


        </div>
    )

}


export default ReloadModal
